import {useCallback, useState} from 'react';
import type {Job} from '@cp/model';
import {jobCreateQuestionValidationGpt} from '../../api/callable/jobs';

export function useCreateQuestionValidationGptJob() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);

  /**
   * Create a question validation GPT job
   * @param moduleId - The module ID to validate questions for
   * @param topics - Optional array of topics to validate (if not provided, validates all topics)
   * @param difficulties - Optional array of difficulties to validate (if not provided, validates all difficulties)
   * @param runLimit - Optional limit on the number of questions to validate
   * @returns The created job document
   */
  const createQuestionValidationGptJob = useCallback(
    async (moduleId: string, topics?: string[], difficulties?: number[], runLimit?: number): Promise<Job> => {
      setLoading(true);
      setError(undefined);
      try {
        return await jobCreateQuestionValidationGpt({moduleId, topics, difficulties, runLimit});
      } catch (err) {
        const e = err instanceof Error ? err : new Error(String(err));
        setError(e);
        throw e;
      } finally {
        setLoading(false);
      }
    },
    [],
  );

  return {
    createQuestionValidationGptJob,
    loading,
    error,
  };
}
